<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />

    <!--客户搜索筛选框-->
    <search-inherit :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <empty-component v-if="isEmpty" />
    <van-list v-model="loading" :finished="finished"  finished-text="没有更多了" v-hasPermi="['scrm:customer:list']" @load="handleNo" v-if="list.length > 0">
      <total-component :totalValue="total" />
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="flex-c-center" v-if="item">
         <div>
            <div class="custName-wrap">
              <div class="custName">
                <van-icon name="bookmark" color="green" />{{ item.custName }}
                <van-tag type="primary">
                  <span v-if="item.logType == 0">客户</span>
                  <span v-if="item.logType == 1">商机</span>
                  <span v-if="item.logType == 2">合同</span>
                  <span v-if="item.logType == 3">收款</span>
                  <span v-if="item.logType == 4">垫款</span>
                </van-tag>
                <span>
                  <!-- <van-tag round>{{ formatHandel('contractStatus',item.contractStatus) }}</van-tag> -->
                  <!-- <van-tag round type="success" v-if="item.contractStatus == 2">执行中</van-tag>
                  <van-tag round type="danger" v-if="item.contractStatus == 3">结束</van-tag>
                  <van-tag round type="warning" v-if="item.contractStatus == 4">意外中止</van-tag> -->
                </span>
              </div>
            </div>
            <div style="color: #1989fa">
              <!-- <van-tag plain style="margin-right:5px" type="primary" v-if="item.custName">{{item.custName}}</van-tag>  -->
              <!-- 【{{item.custName}}】 -->
            </div>
            <div>
              <div>
                <!-- <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.templateType">{{ formatHandel('templateType',item.templateType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.payType">{{ formatHandel('payType',item.payType) }}</van-tag>
                <van-tag color="#999" style="margin-right: 5px" plain type="primary" v-if="item.frameType">{{ formatHandel('frameType',item.frameType) }}</van-tag>
                <van-tag color="#999" plain type="primary" v-if="item.custSource">{{ formatHandel('custSource',item.custSource) }}</van-tag> -->
              </div>
              <div style="color: #666; font-size: 12px">业务部门名称：{{item.deptName}}</div>
              <div style="color: #999; font-size: 12px">原跟进人：{{item.oldUserName}} <span style="margin-left: 5px">现跟进人： {{item.newUserName}}</span></div>
              <div style="color: #aaa; font-size: 12px">操作人姓名：{{item.createBy}} <span style="margin-left: 5px">操作日期： {{item.createTime}}</span></div>
            </div>
          </div>
          <!-- <van-icon color="#c1c1c1" name="arrow" size="16" class="arrow-color"  @click="toContractDetails(item)" /> -->

        </div>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import { getCustomerInheritLogList } from '@/api/scrm/mycust'
// import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import TotalComponent from '@/components/common/Total'
import SearchInherit from '../component/SearchInherit.vue'
import EmptyComponent from '@/components/common/Empty'
export default {
  name: 'inheritLog',
  components: {
    SearchComponent,
    SearchInherit,
    EmptyComponent,
    TotalComponent
  },
  data() {
    return {
      isEmpty: false,
      loading: false,
      finished: false,
      list: [],
      total: 0,
      showFilterPop: false,
      searchValue: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptName: null,
        oldUserName: null,
        newUserName: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  // created(){
  //
  // },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '客户继承日志'
      await this.handleNo()
    },
    QueryReset() {
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        deptName: null,
        oldUserName: null,
        newUserName: null,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.isEmpty = false
      this.QueryReset()
      this.queryParams.custName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      this.isEmpty = false
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleNo()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },
    async handleNo() {
      this.loading = true
      const res = await getCustomerInheritLogList(this.queryParams)

      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.queryParams.pageNum += 1
        this.total = res.total
        this.loading = false
        this.finished = this.list.length >= res.total
        this.showFilterPop = false
      }
    },
    onLoad() {
      this.handleNo()
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.tab{
  padding-top: 100px;
  margin-bottom: -100px;
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
</style>
